import PropTypes from 'prop-types';

const ValueShape = PropTypes.shape({
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ])
});

const OptionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: ValueShape
});

const GroupShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(OptionShape)
});

export {
  ValueShape,
  OptionShape,
  GroupShape
};
